import { ReactComponent as SDIcon } from "components/icons/sd.svg";
import { ReactComponent as HDIcon } from "components/icons/hd.svg";
import { clsx } from "clsx";
import "./QualityButton.scss";

enum QualityType {
  SD = "sd",
  HD = "hd",
}

interface IQualityButtonProps {
  quality: string;
  onChange: (quality: string) => void;
}

export const QualityButton: React.FC<IQualityButtonProps> = ({
  quality,
  onChange
}) => {
  const isSDQuality = quality === QualityType.SD;

  return (
    <button
      onClick={() => onChange(isSDQuality ? QualityType.HD : QualityType.SD)}
      className={clsx("QualityButton", isSDQuality ? QualityType.SD : QualityType.HD)}
    >
      {isSDQuality ? <SDIcon /> : <HDIcon />}
    </button>
  );
};
